// src/features/wallet/components/WalletTable.tsx
import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';

import { formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { Wallet } from '../types/wallet.types';
import { WalletStatusBadge } from './WalletStatusBadge';

export interface WalletTableProps {
  wallets: Wallet[];
}

/**
 * Wallet list table. Presentation only — takes its rows as a prop
 * instead of reading useWalletMock itself, so it stays decoupled from
 * where the data comes from; a later phase's real wallet hook can
 * feed the same `wallets` prop without this component changing. Same
 * shape as commission/components/CommissionTable.tsx and
 * orders/components/OrderTable.tsx: wrapped in the shared glass-card
 * `Card` primitive (noPadding, table owns its own cell padding) with
 * a horizontal-scroll rail for narrow viewports.
 *
 * Rows are clickable and call navigate(`/wallet/${wallet.id}`), which
 * resolves to the WalletWorkspacePage foundation route.
 */
export function WalletTable({ wallets }: WalletTableProps) {
  return (
    <div className="vania-wallet-table-scroll">
        <table className="vania-wallet-table">
          <thead>
            <tr>
              <th>شناسه کاربر</th>
              <th>کاربر</th>
              <th>Telegram ID</th>
              <th>موبایل</th>
              <th>موجودی</th>
              <th>وضعیت</th>
              <th>تاریخ ایجاد</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {wallets.map((wallet) => (
              <tr
                key={wallet.id}
                className="vania-wallet-table-row"
              >
                <td className="vania-wallet-table-name">{wallet.id}</td>
                <td>{wallet.full_name || wallet.username || '-'}</td>
                <td dir="ltr">{wallet.telegram_id}</td>
                <td dir="ltr">{wallet.mobile || '-'}</td>
                <td dir="ltr">{formatPersianNumber(wallet.balance)}</td>
                <td>
                  <WalletStatusBadge status={wallet.status} />
                </td>
                <td dir="ltr">{formatSolarDate(wallet.created_at || '-')}</td>
                <td><Link className="vania-wallet-row-action" to={`/wallet/${wallet.id}`} aria-label="مشاهده کیف پول" title="مشاهده"><Eye size={14} aria-hidden="true" /><span className="sr-only">مشاهده</span></Link></td>
              </tr>
            ))}
          </tbody>
        </table>
    </div>
  );
}
